export const getAuthToken = () => {
  return JSON.parse(localStorage.getItem(process.env.REACT_APP_AUTH_TOKEN_KEY ?? '') ?? '') as string;
};
